import cn from 'classnames'
import dynamic from 'next/dynamic'
import React, { memo } from 'react'
// import { ReviewsContainer } from 'src/components/ReviewsContainer/ReviewsContainer'
// import { SolutionEnhancedPricing } from 'src/components/SolutionsPage/SolutionEnhancedPricing/SolutionEnhancedPricing'
// import { SolutionEnhancedVideos } from 'src/components/SolutionsPage/SolutionEnhancedVideos/SolutionEnhancedVideos'
// import { DetailContainer } from 'src/components/VendorEnhancedDetailContainer/Detail/DetailContainer'
// import { ResourcesContainer } from 'src/components/VendorEnhancedDetailContainer/Resources/ResourcesContainer'
import {
  IProductSolutionDataFragment,
  ISimilarSolutionItemFragment,
  ITestimonialItemFragment,
} from 'src/graphql/generated/hooks'
import {
  DETAILS_TAB,
  PRICING_TAB,
  PRODUCT_BRIEFING_TAB,
  RESOURCE_TAB,
  VENDOR_ANALYSIS_TAB,
  VIDEOS_TAB,
} from 'src/types'

import { ThemeOnly } from '../global/ThemeOnly'
import SkeletonLoading from '../SkeletonLoading/SkeletonLoading'
import SolutionVendorAnalysisContainer from '../SolutionsPage/SolutionVendorAnalysisContainer/SolutionVendorAnalysisContainer'
// import { Testimonials } from '../Testimonials/Testimonials'

interface VendorEnhancedDetailContainerProps {
  className?: string
  vendor: IProductSolutionDataFragment
  tabIdx: number
  similars: ISimilarSolutionItemFragment[]
  analysisTotal: number
  productBriefingTotal: number
  testimonials?: ITestimonialItemFragment[]
  relatedContent?: any[]
  totalRelatedContent?: number
}

/**
 * Primary UI component for user interaction
 */

const DetailContainer = dynamic(
  () =>
    import('src/components/VendorEnhancedDetailContainer/Detail/DetailContainer').then((mod) => mod.DetailContainer),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
// const ReviewsContainer = dynamic(
//   () => import('src/components/ReviewsContainer/ReviewsContainer').then((mod) => mod.ReviewsContainer),
//   {
//     loading: () => <SkeletonLoading className="bg-navy" />,
//   },
// )
const SolutionEnhancedVideos = dynamic(
  () =>
    import('src/components/SolutionsPage/SolutionEnhancedVideos/SolutionEnhancedVideos').then(
      (mod) => mod.SolutionEnhancedVideos,
    ),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
const SolutionEnhancedPricing = dynamic(
  () =>
    import('src/components/SolutionsPage/SolutionEnhancedPricing/SolutionEnhancedPricing').then(
      (mod) => mod.SolutionEnhancedPricing,
    ),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)
const ResourcesContainer = dynamic(
  () =>
    import('src/components/VendorEnhancedDetailContainer/Resources/ResourcesContainer').then(
      (mod) => mod.ResourcesContainer,
    ),
  {
    loading: () => <SkeletonLoading className="bg-navy" />,
  },
)

export const VendorEnhancedDetailContainer: React.FC<VendorEnhancedDetailContainerProps> = memo(
  ({
    className,
    vendor,
    tabIdx,
    similars,
    analysisTotal,
    productBriefingTotal,
    // testimonials,
    relatedContent,
    totalRelatedContent = 0,
  }) => {
    const showResourcesTab = (vendor?.vendorResources || []).length > 0

    /* const vendorResourcesTL = vendor?.attributes?.vendorResources?.filter((resource) => {
      if (!resource) return false

      // For Content type resources
      if (resource.type === 'Content') {
        const contentType = resource.content?.data?.attributes?.contentType
        const documentType = resource.content?.data?.attributes?.documentType

        // Exclude if contentType is "Vendor_Analysis" OR documentType is "Product_Briefing"
        if (contentType === 'Vendor_Analysis' || documentType === 'Product_Briefing') {
          return false
        }
      }

      // For External type resources
      if (resource.type === 'External') {
        const documentType = resource.external?.documentType

        // Exclude if documentType is "Product_Briefing"
        if (documentType === 'Product_Briefing') {
          return false
        }
      }

      return true
    }) */

    return (
      <div className={cn(className, 'flex flex-col justify-center w-full px-5')}>
        {tabIdx === DETAILS_TAB && (
          <DetailContainer
            key={vendor?.slug + '-DetailContainer'}
            vendor={vendor}
            similars={similars || []}
            relatedContent={relatedContent || []}
            totalRelatedContent={totalRelatedContent || 0}
          />
        )}
        {/* {tabIdx === REVIEWS_TAB && (
          <ReviewsContainer
            key={vendor.attributes?.slug + '-ReviewsContainer'}
            reviews={vendor.attributes?.reviews?.data || []}
            isShowSubmit={true}
            title={vendor?.displayName || ''}
            solutionType={IEnum_Solution_Type.Product}
            id={vendor?.documentId || ''}
            isProgressing={false}
            isEnhanced
          />
        )} */}
        {tabIdx === VIDEOS_TAB && (
          <SolutionEnhancedVideos
            key={vendor?.slug + '-SolutionEnhancedVideos'}
            screenshots={vendor?.productData?.enhancedListingData?.screenshots || []}
            videos={vendor?.productData?.enhancedListingData?.videos || []}
          />
        )}
        {tabIdx === PRICING_TAB && (
          <SolutionEnhancedPricing key={vendor?.slug + '-SolutionEnhancedPricing'} solution={vendor} />
        )}
        {showResourcesTab && tabIdx === RESOURCE_TAB && (
          <ResourcesContainer key={vendor?.slug + '-ResourcesContainer'} vendor={vendor} />
        )}
        {tabIdx === VENDOR_ANALYSIS_TAB && (
          <ThemeOnly theme="legaltech">
            <SolutionVendorAnalysisContainer
              key={vendor?.slug + '-SolutionVendorAnalysisContainer'}
              solutionId={vendor?.documentId || ''}
              analysisTotal={analysisTotal}
            />
          </ThemeOnly>
        )}
        {tabIdx === PRODUCT_BRIEFING_TAB && (
          <>
            <SolutionVendorAnalysisContainer
              key={vendor?.slug + '-SolutionProductBriefingContainer'}
              solutionId={vendor.documentId || ''}
              analysisTotal={productBriefingTotal}
              documentType="Product Briefing"
            />
          </>
        )}
        {/* <ThemeOnly theme="legaltech">
        <Testimonials testimonials={testimonials || []} />
      </ThemeOnly> */}
      </div>
    )
  },
)
